import { DeleteCalendarEventInput, ID } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type DeleteExternalCalendarEventResult = { id: ID };

export type DeleteExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: DeleteCalendarEventInput;
};

export const deleteExternalCalendarEvent = async <TFunctions>(
  options: DeleteExternalCalendarEventOptions<TFunctions>,
): Promise<DeleteExternalCalendarEventResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    DeleteCalendarEventInput,
    DeleteExternalCalendarEventResult
  >(functions, 'externalCalendars-deleteEvent');

  const { data } = await callable(payload);

  return data;
};
